var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-breadcrumb mb-2"},[_c('router-link',{staticStyle:{"text-transform":"uppercase","font-size":"19px"},attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$tc('report', 2)))]),_vm._v(" > "),_c('router-link',{attrs:{"to":_vm.$route.path}},[_vm._v(_vm._s(_vm.$t(_vm.$route.name.split(" ").join("_").toLowerCase())))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }